<template>
	<div class="scoreboard">
		<div class="scoreboard__header">
			<neon :text="'Hall of Fame'" :size="'small'" />
		</div>
		<div v-if="currentScore > minScore && !scoreSent" class="scoreboard__add">
			<p>🎉 Félicitations, vous entrez <br v-if="mobile">dans le Hall of Fame&nbsp;!</p>
			<div class="scoreboard__send">
				<input class="scoreboard__input" tabindex="98" type="text" v-model="currentPlayerName" placeholder="Entrez votre pseudo" />
				<app-button class="scoreboard__submit" tabindex="99" :wording="'Envoyer'" :type="'badass'" @click="setScore()" />
			</div>
		</div>
		<div ckass="scoreboard__players">
			<div class="players">
				<div v-for="player in refinedPlayers" class="player" :key="player.pos">
					<div class="player__pos">
						{{player.pos}}
					</div>
					<div class="player__name">
						{{player.name}}
					</div>
					<div v-if="!mobile" class="player__date">
						{{player.date}}
					</div>
					<div class="player__score">
						<span>{{player.scoreTxt}}</span>&nbsp;pts
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { isDev, padNumber, isSafari } from 'global/js/apps.js'
	import AppButton from 'global/components/AppButton'
	import Neon from '../components/Neon'
	const urls = {
		scoreboard: 'https://apps.contexte.com/data/ctx-gaming/scoreboards.json',
		setScore: 'https://apps.contexte.com/set-high-score',
	}
	export default {
		name: 'Scoreboard',
		components: { AppButton, Neon },
		props: {
			scoreSent: {
				type: Boolean,
				required: true,
			},
			currentScore: {
				type: Number,
				default: null,
			},
		},
		data: function() {
			return {
				players: [],
				currentPlayerName: '',
				isDev: isDev(),
				mobile: false,
				breakpoints: {
					mobile: 600,
				},
			}
		},
		methods: {
			setScore: function() {
				let url = urls['setScore']
				url += '?player=' + encodeURIComponent(this.currentPlayerName) + '&score=' + this.currentScore + '&scoreboard=siglotron'
				if (this.isDev) console.log(url)
				fetch(url, {cache: 'no-store'})
				.then(response => response.json())
				.then(json => {
					if (this.isDev) console.log(json)
					this.players = json.scoreboard.players
					this.$emit('sent')
				})
			}
		},
		created() {
			if (window.innerWidth <= this.breakpoints.mobile) this.mobile = true
			if (this.isDev) console.log(urls.scoreboard)                
			fetch(urls['scoreboard'], {cache: 'no-store'})
			.then(response => response.json())
			.then(json => {
				this.players = json.find(s => s.name == 'siglotron').players

			})
		},
		computed: {
			refinedPlayers: function() {
				return this.players.reduce((acc, player, p) => {
					player['pos'] = p+1
					player['scoreTxt'] = padNumber(player.score, 6)
					let date = new Date(player.date)
					if (isSafari()) {
						date = new Date(player.date.replace(/ /g,'T'))
					} 
					player.date = date.toLocaleString('fr-FR', {
						day: 'numeric',
						month: 'long',
						year: 'numeric',
						hour: 'numeric',
						minute: 'numeric'
					})
					return acc.concat(player)
				}, [])
			},
			minScore: function() {
				return this.refinedPlayers.reduce((acc, player) => {
					if (player.score < acc) return player.score
					return acc  
				}, 1000000)
			}
		},
		watch: {
			currentPlayerName: function(name) {
				if (name.length > 10) this.currentPlayerName = name.slice(0, 10)
			}
		}
	}
</script>
<style lang="scss" >
	@import 'global/css/contexte.apps.colors.2.0';
	.scoreboard {
		max-width: 700px;
		margin-left: auto;
		margin-right: auto;
		&__header {
			font-weight: 600;
			font-size: 1.2em;
			margin-bottom: 1.5em;
		}
		&__add {			
			p {
				margin-bottom: 2em;
			}
		}
		&__send {
			display: flex;
			width: calc(100% + 2em);
			margin: 0 -1em;
			justify-content: center;
			> input, > button {
				margin-left: 1em !important;
				margin-right: 1em !important;
			}
		}
		&__input {
			flex: 1 1 300px;
			max-width: none;
			font-size: 1.2em;
			text-transform: uppercase;
		}
		&__submit {
			flex: 0 0 40px;
			height: 45px;
			font-size: 1em;
		}
	}
	.players {
		min-width: 550px;
		padding: 0 2em;
	}
	.player {
		border-top: 1px solid $light-grey;
		padding-top: .7em;
		display: flex;
		margin: 0 -.5em 1em;
		width: calc(100% + 1em);
		align-items: center;
		> div {
			margin-left: .5em;
			margin-right: .5em;
		}
		&__pos {
			flex: 0 0 30px;
			text-align: left;
		}
		&__name {
			text-transform: uppercase;
			font-size: 1.2em;
			font-weight: 600;
			flex: 1 1 200px;
			text-align: left;
		}
		&__date {
			flex: 1 1 200px;
			font-size: .9em;
			text-align: center;
		} 
		&__score {
			text-transform: uppercase;
			flex: 0 0 120px;
			text-align: right;
			span {
				color: #28e9f3;
			}
		}
	}
	@media screen and (max-width: 600px)  {
		.scoreboard {
			&__add {
				padding: 0 2em;
			}
			&__input {
				font-size: 16px;
			}
			&__submit {
				min-width: 0;
				padding: 0 .8em;
				flex-basis: 110px; 
			}
		}
		.players {
			min-width: 0;
		}
		.player {
			> div {
				min-width: 0;
			}
			&__name {

			}
			&__pos {
				flex: 0 0 15px;
			}
			&__score {
				flex: 0 0 90px;
			}
		}
	}
</style>